var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69184",
    "data-name": "Group 69184",
    transform: "translate(10152 874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14906",
    "data-name": "Rectangle 14906",
    width: 16,
    height: 16,
    transform: "translate(-10152 -874)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(-10149.791 -873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33501",
    "data-name": "Path 33501",
    d: "M14.936,9.811l-.514-.819a2.373,2.373,0,0,1-.363-1.261V5.7a4.595,4.595,0,1,0-9.189,0V7.73a2.374,2.374,0,0,1-.363,1.261l-.514.819a2.084,2.084,0,0,0-.319,1.11v.508a1.311,1.311,0,0,0,1.31,1.31h2.2c0,.026-.005.051-.005.078a2.284,2.284,0,1,0,4.567,0c0-.026,0-.051-.005-.078h2.2a1.311,1.311,0,0,0,1.31-1.31v-.508a2.084,2.084,0,0,0-.319-1.11ZM10.9,12.816a1.439,1.439,0,1,1-2.877,0c0-.027,0-.052.005-.078H10.9c0,.026.006.051.006.078Zm3.508-1.387a.464.464,0,0,1-.464.464H4.982a.464.464,0,0,1-.464-.464v-.508a1.24,1.24,0,0,1,.19-.661l.514-.819A3.217,3.217,0,0,0,5.715,7.73V5.7a3.749,3.749,0,1,1,7.5,0V7.73a3.217,3.217,0,0,0,.492,1.711l.514.819a1.24,1.24,0,0,1,.19.661Z",
    fill: "currentColor",
    transform: "translate(-3.672 -1.1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b685ffeb90385faa04bd2bf1510c8947.svg";
export { ForwardRef as ReactComponent };